import React, { useEffect, useMemo } from "react"
import { useLocation } from "@reach/router";
import { StaticImage } from "gatsby-plugin-image"
import { isAndroid, isMobile } from "react-device-detect"
import SeoType from "../../types/seo.type"
import useQueryParams from "query-params-hook"
import { useLocalStorage } from 'usehooks-ts'
import { useStaticQuery, graphql } from "gatsby"

const SmartBanner = ({
  shouldShowBanner = false,
  setShouldShowBanner,
  ctaLink,
}: Pick<SeoType, "shouldShowBanner" | "setShouldShowBanner" | "ctaLink">) => {
  const { pathname } = useLocation();
  const { page_version, lp } = useQueryParams()
  const [showBanner, setShowBanner] = useLocalStorage("showBanner", true);

  const data = useStaticQuery(graphql`
    query {
      allContentfulComposePage {
        nodes {
          slug
          adjustLink {
            adjustLink
          }
        }
      }
    }
  `) as any;

  const adjustLinkData = data.allContentfulComposePage.nodes.find(
    (node: any) => `/${node.slug}/` === pathname
  );
  const adjustLink = adjustLinkData?.adjustLink?.adjustLink;

  const url = useMemo(() => {
    if (adjustLink) {
      return adjustLink;
    }
    // specific case for /blog/...
    if (pathname.includes('/blog')) {
      return 'https://jackpotparty.go.link?adj_t=1fwi00co_1fpdipro_1fohsk1v'
    }
    if (ctaLink) {
      return ctaLink
    }

    return isAndroid
      ? "https://app.adjust.com/113z4xk4"
      : "https://app.adjust.com/11uy0jlw"
  }, [isAndroid, pathname])

  useEffect(() => {
      setShouldShowBanner?.(
          showBanner &&
          isMobile && !page_version && lp != "true"
      )
  }, [])

  if (!shouldShowBanner) {
    return null
  }

  return (
    <div className="smart-banner fixed top-0 left-0 right-0 bg-[#f2f2f2] text-white p-6 flex z-[100] border-b-2 border-b-[#f2f2f2] border-solid">
      <span
        className="mr-4 invert self-center"
        onClick={() => {
          setShowBanner(false);
          setShouldShowBanner?.(false)
        }}
      >
        <StaticImage
          width={16}
          src="../../images/close-popup.png"
          alt="close icon"
        />
      </span>
      {isAndroid ? (
        <StaticImage
          className="mr-4 rounded-3xl max-h-[65px] mt-auto mb-auto"
          width={65}
          src="../../images/android-icon.png"
          alt="Jackpot Party Mobile"
        />
      ) : (
        <StaticImage
          className="mr-4 rounded-3xl max-h-[65px] mt-auto mb-auto"
          width={65}
          src="../../images/ios-icon.png"
          alt="Jackpot Party Mobile"
        />
      )}
      <div className="flex flex-col">
        <span className="text-black text-lg font-bold">
          Jackpot Party - Casino Slots
        </span>
        <span className="text-[#676767] text-lg">SciPlay</span>
        <div className="text-[#676767] text-lg">
          <span data-star="4.8" />
          4.8
        </div>
        <span className="text-[#676767] text-lg">
          Free - {isAndroid ? "On Google Play" : "On the App Store"}
        </span>
      </div>
      <a
        href={url}
        className="text-white bg-[#1d70df] text-[12px] p-2 ml-auto my-auto rounded-md"
      >
        {ctaLink ? "Play Now" : "Install"}
      </a>
    </div>
  )
}

export default SmartBanner
